export default __webpack_public_path__ + "static/media/productions.87c1228d.svg";